import * as yup from "yup";

export const fieldLogSchema = yup.object({
  visit_date: yup.string().required("Visit date is required"),

  visit_start_time: yup.string().required("Visit start time is required"),

  visit_end_time: yup.string().required("Please capture the visit end time"),

  staffName: yup.string().required("Field staff name is required"),

  county: yup.string().required("County is required"),

  location: yup.string().required("Location is required"),

  supplier_id: yup.string().required("Supplier is required"),
  contact_phonenumber: yup.string().required("Phone number is required"),

  gps_coordinates: yup
    .string()
    .required("GPS coordinates are required — tap Capture GPS"),

  // FIX: Converted Zod file logic to standard Yup file testing
  photo_evidence_url: yup
    .mixed()
    .required("Photo evidence is required")
    .test("fileType", "Only JPG, PNG or WebP images are accepted", (value) => {
      if (!value) return false;
      return ["image/jpeg", "image/png", "image/webp"].includes(value.type);
    })
    .test("fileSize", "Photo must be under 10MB", (value) => {
      if (!value) return false;
      return value.size <= 10 * 1024 * 1024;
    }),
});
